import React from 'react'
import { Modal } from '@components/ui'

type MessageCenterDeleteEmailOrganizeModalProps = {
  show: boolean
  itemType: 'folder' | 'label'
  itemName?: string
  onCancel: () => void
  onDelete: () => void
}

const MessageCenterDeleteEmailOrganizeModal: React.FC<
  MessageCenterDeleteEmailOrganizeModalProps
> = ({ show, itemType, itemName, onCancel, onDelete }) => {
  const isFolder = itemType === 'folder'
  const name = itemName?.trim() || `this ${itemType}`

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="xs"
      title={isFolder ? 'Delete folder' : 'Delete label'}
      description={
        isFolder
          ? 'Are you sure you want to delete this folder? Emails in this folder will return to the inbox.'
          : `Are you sure you want to delete ${name}? This label will be removed from the emails that use it.`
      }
      primaryLabel="Delete"
      secondaryLabel="Cancel"
      primaryDestructive
      onPrimaryClick={onDelete}
      onSecondaryClick={onCancel}
    />
  )
}

export default MessageCenterDeleteEmailOrganizeModal
